import { atom } from "recoil";
import { MyDashboardActiveBrand } from "@/features/my-dashboard/types";

export const myDashboardActiveBrandStore = atom<MyDashboardActiveBrand>({
  key: "myDashboardActiveBrandStore",
  default: {},
});
